import React from 'react';
import AvailabilityPage from '../pages/Availability';
import { objectValues, getPageTitle } from '../utility/utility';
import { logOrThrowError } from '../utility/logging';

export default class AvailabilityPageContainer extends React.Component {
  constructor(props) {
    super(props);
    this.filter = this.props.params && this.props.params.id;
    this.filter_array = [
      {
        id: 'All',
        label: 'All',
      },
      {
        id: 'Studio',
        label: 'Studio',
      },
      {
        id: '1 Bedroom',
        label: '1 Bedroom',
      },
      {
        id: '2 Bedroom w/1 bath',
        label: '2 Bedroom w/1 bath',
      },
      {
        id: '2 Bedroom w/2 bath',
        label: '2 Bedroom w/2 bath',
      },
    ];
    this.state = {
      filters: {
        layout: 'All',
      },

      sort: {
        attr: 'price',
        direction: 'reverse',
      },
    };

    this.updateListingOptions = this.updateListingOptions.bind(this);
  }

  static pageTitle(listings, routeParams) {
    // eslint-disable-line no-unused-vars
    return 'Studio, 1 & 2 Bed Apartments in Fort Greene | 300 Ashland Pl';
  }
  parseRouteParams() {
    let text = '';

    switch (this.filter) {
      case 'studio':
        text = 'Studio';
        break;
      case 'one-bedroom':
        text = '1 Bedroom';
        break;
      case 'two-bedroom-one-bath':
        text = '2 Bedroom w/1 bath';
        break;
      case 'two-bedroom-two-bath':
        text = '2 Bedroom w/2 bath';
        break;
      default:
        text = 'All';
        break;
    }
    // console.log(text)
    return text;
  }
  sortBy(arr, val, prop) {
    var top = [];
    var rest = [];

    for (var el of arr) {
      if (el[prop] == val) {
        top.push(el);
      } else {
        rest.push(el);
      }
    }
    return top.concat(rest);
  }

  componentDidMount() {
    // console.log(this.state.filters)
    this.props.syncListings();
    if (this.filter) {
      let formatted_filter = this.parseRouteParams(this.filter);
      this.updateListingOptions({ filters: { layout: formatted_filter } });
    }
  }

  updateListingOptions(newOptions) {
    let newUrl = '/availability/';
    switch (newOptions.filters.layout) {
      case 'Studio':
        newUrl += 'studio';
        break;
      case '1 Bedroom':
        newUrl += 'one-bedroom';
        break;
      case '2 Bedroom w/1 bath':
        newUrl += 'two-bedroom-one-bath';
        break;
      case '2 Bedroom w/2 bath':
        newUrl = 'two-bedroom-two-bath';
        break;
      default:
        newUrl = String(newUrl);
        break;
    }
    window.history.pushState({}, null, newUrl);
    this.setState({ ...newOptions });
  }

  render() {
    // If the listings have loaded already, filter them to the valid ones.
    // If not, we'll just use the non-loaded (i.e., error or undefined) value
    // for the listings as the valid listings
    const listings = this.props.listings;
    const listingsLoadedSuccessfully =
      typeof listings !== 'undefined' && !(listings instanceof Error);

    const validListings = listingsLoadedSuccessfully
      ? computeValidListings(
          objectValues(listings).filter(
            (listing) => !(listing instanceof Error)
          ),
          this.state.sort,
          this.state.filters
        )
      : this.props.listings;
    return (
      <AvailabilityPage
        listings={validListings}
        filters={
          this.filter
            ? this.sortBy(
                this.filter_array,
                this.parseRouteParams(this.filter),
                'id'
              )
            : this.filter_array
        }
        sort={this.state.sort}
        pageTitle={getPageTitle(this.constructor, this.props)}
        updateListingOptions={this.updateListingOptions}
      />
    );
  }
}

function computeValidListings(allListings, sort, filters) {
  let filteredListings = filterListingsByLayout(allListings, filters.layout);
  let sorter =
    sort.direction === 'normal'
      ? (a, b) => a[sort.attr] - b[sort.attr]
      : (a, b) => b[sort.attr] - a[sort.attr];

  return filteredListings.sort(sorter);
}

function filterListingsByLayout(allListings, layoutFilter) {
  const hasOneBath = (it) => Number(it.bathroomCount) === 1;
  const hasTwoBath = (it) => Number(it.bathroomCount) === 2;

  switch (layoutFilter) {
    case 'All':
      return allListings.slice();

    case 'Studio':
    case '1 Bedroom':
    case '3 Bedroom':
      return allListings.filter((it) => it.layoutName === layoutFilter);

    case '2 Bedroom w/1 bath':
      // layoutName is "2 Bedroom", whereas layoutFilter is the whole string
      // "2 bedroom w/1 bath", hence the `startsWith`.
      return allListings.filter(
        (it) => layoutFilter.startsWith(it.layoutName) && hasOneBath(it)
      );

    case '2 Bedroom w/2 bath':
      return allListings.filter(
        (it) => layoutFilter.startsWith(it.layoutName) && hasTwoBath(it)
      );

    default:
      logOrThrowError(
        new Error('Invalid listings layout filter: ' + layoutFilter)
      );
      return allListings.slice();
  }
}



// WEBPACK FOOTER //
// ./client/containers/AvailabilityPageContainer.js